import type MessageStatusHistoryTableVM from 'ab-viewModels/message/messageStatusHistoryTable.viewModel';

const MESSAGE_STATUS_HISTORY_TABLE_CSV_HEADER = [
	'Created At',
	'Status',
	'Metadata',
];

export const toCSVData = (viewModels: MessageStatusHistoryTableVM[]): string[][] => {
	const header: string[] = [...MESSAGE_STATUS_HISTORY_TABLE_CSV_HEADER];

	const rows = viewModels.reduce((_acc, _status) => {
		_acc.push([
			_status.createdAt,
			_status.status,
			(_status.createdMetadata ?? _status.createdMetadata) ?? '-',
		]);
		return _acc;
	}, [] as string[][]);

	return [header, ...rows];
};
